// preset: https://vuetifyjs.com/en/customization/presets/
// icons: https://materialdesignicons.com/
// colors: https://vuetifyjs.com/en/customization/theme/
//        https://vuetifyjs.com/en/styles/colors/

import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    default: 'light',
    themes: {
      light: {
        primary: '#293D47',
        secondary: '#E9CC62',
        accent: '#E9CC62',
        error: '#FF5252',
        info: '#283c46',
        success: '#ADCE6D',
        warning: '#FF5353',
      },
      dark: {
        primary: '#2196F3',
        secondary: '#E9CC62',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
      },
    },
  },
});
